import { CAMPAIGNS_FAILURE, CAMPAIGNS_REQUEST, CAMPAIGNS_SUCCESS, CampaignsActionTypes, State } from "./types";

const initialState: State = {
  loading: false,
};

export function campaignsReducer(state = initialState, action: CampaignsActionTypes): State {
  switch (action.type) {
    case CAMPAIGNS_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined,
      };

    case CAMPAIGNS_SUCCESS:
      return {
        ...state,
        campaigns: action.payload.data.map((p) => ({
          id: p.id,
          type: p.type,
          code: p.attributes.code,
          causedPart: p.attributes["caused-part"],
          status: p.attributes.status,
          description: p.attributes.description,
          descriptionDetailed: p.attributes["description-detailed"],
        })),
        loading: false,
      };

    case CAMPAIGNS_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
}
